<template>
    <div>
        <slot
            :fields="fields"
            :handleForm="handleForm"
        />
    </div>
</template>

<script>
    let stripe;
    let elements;
    let card;

    export default {
        name: 'checkoutPayment',
        props: {
            stripeKey: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                fields: {
                    paymentMethod: 'ideal',
                    bank: '',
                },
                disabled: false,
            };
        },
        mounted() {
            if (window.Stripe) {
                stripe = window.Stripe(this.stripeKey);
                elements = stripe.elements();
                card = elements.create('card');

                card.mount('#card-element');

                card.addEventListener('change', (event) => {
                    const displayError = document.getElementById('card-errors');
                    if (event.error) {
                        displayError.textContent = event.error.message;
                    } else {
                        displayError.textContent = '';
                    }
                });
            }
        },
        methods: {
            handleForm({ currentTarget }) {
                if (!this.disabled) {
                    this.disabled = true;

                    if (this.fields.paymentMethod === 'card') {
                        stripe.createToken(card).then((result) => {
                            if (result.error) {
                                const errorElement = document.getElementById('card-errors');
                                errorElement.textContent = result.error.message;
                                this.disabled = false;
                            } else {
                                this.stripeTokenHandler(result.token, currentTarget);
                            }
                        });
                    } else {
                        currentTarget.submit();
                    }
                }
            },
            stripeTokenHandler(token, form) {
                const hiddenInput = document.createElement('input');
                hiddenInput.setAttribute('type', 'hidden');
                hiddenInput.setAttribute('name', 'stripeToken');
                hiddenInput.setAttribute('value', token.id);
                form.appendChild(hiddenInput);
                form.submit();
            },
        },
    };
</script>
